import { Controller } from "@hotwired/stimulus"
import { NotificationChannel } from "../channels"

export default class extends Controller {
  connect() {
    this.channel = new NotificationChannel({
      onMention: (notification) => { this.updateBadge(); this.showToast(notification, "mention") },
      onNewMessage: (notification) => this.showToast(notification, "message")
    }).connect()
  }

  disconnect() {
    this.channel?.disconnect()
  }

  updateBadge() {
    let badge = document.getElementById("notification-badge")
    if (!badge) {
      // Create badge if it doesn't exist
      const bellLink = document.querySelector('a[href*="notifications"]')
      if (!bellLink) return
      badge = document.createElement("span")
      badge.id = "notification-badge"
      badge.className = "absolute -top-0.5 -right-0.5 inline-flex items-center justify-center min-w-[16px] h-4 px-1 bg-red-500 text-white text-[10px] font-bold rounded-full"
      bellLink.appendChild(badge)
    }
    const current = parseInt(badge.textContent) || 0
    const next = current + 1
    badge.textContent = next > 99 ? "99+" : next
  }

  showToast(notification, type) {
    const title = type === "mention"
      ? `${notification.sender_nickname}님이 회원님을 멘션했습니다`
      : `${notification.sender_nickname}: ${notification.content}`

    const toast = document.createElement("div")
    toast.className = "fixed top-4 right-4 z-50 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-lg px-4 py-3 max-w-sm cursor-pointer"
    toast.innerHTML = `
      <div class="flex items-start gap-3">
        <div class="h-8 w-8 rounded-full bg-red-500 flex items-center justify-center flex-shrink-0">
          <svg class="h-4 w-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/>
          </svg>
        </div>
        <div class="flex-1 min-w-0">
          <p class="text-sm font-medium text-gray-900 dark:text-white truncate">${this.escapeHtml(title)}</p>
          ${type === "mention" ? `<p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5 truncate">${this.escapeHtml(notification.content)}</p>` : ""}
        </div>
      </div>
    `

    if (notification.room_id) {
      toast.addEventListener("click", () => {
        window.location.href = `/chat/rooms/${notification.room_id}`
      })
    }

    document.body.appendChild(toast)
    setTimeout(() => toast.remove(), 5000)
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text || ""
    return div.innerHTML
  }
}
